import t from '@rcm/i18n-client';
import React, { ChangeEvent, useCallback } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useFindCurrentCountryRuleQuery } from '../../api';
import { selectShippingCountry, setShippingCountry } from '../../slices/shipping';

const ShippingCountryField = () => {
    const dispatch = useDispatch();
    const country = useSelector(selectShippingCountry);
    const countryRulesQuery = useFindCurrentCountryRuleQuery();

    const handleChangeCountry = useCallback((e: ChangeEvent<HTMLSelectElement>) => {
        dispatch(setShippingCountry(e.target.value));
    }, []);

    return <Row className="mb-3">
        <Form.Group as={Col}>
            <Form.Label>{t('Country')}</Form.Label>
            <Form.Select
                onChange={handleChangeCountry}
                value={country}
                disabled={countryRulesQuery.isFetching}
            >
                {countryRulesQuery.isFetching && <option value={''} disabled>
                    {t('Loading...')}
                </option>}
                {countryRulesQuery.isSuccess &&
                    Object.entries(countryRulesQuery.data.allowedCountries)
                        .map(([iso, label]) =>
                            <option value={iso} key={iso}>{label}</option>
                        )
                }
            </Form.Select>
        </Form.Group>
    </Row>;
}

export default ShippingCountryField;
